import React, {useEffect, useRef, useState} from 'react';
import styled from "styled-components";
import {handleActiveError, handleActiveToast} from "../sonner/ToastBasic";
import Modal from "../modal/Modal";
import {ModalTable, ModalTd, ModalTh} from "../progressBar/LicenseProgressBar";
import {createGroupSelect} from "../../api/field/CustomCodeService";
import {isEmpty} from "../commonmethod/CommonMethod";

const SelectBox = styled.div`
    //position: relative;
    width: 120px;
    height: 30px;
    z-index: 10;
    line-height: 30px;
    padding-left: 5px;
    display: inline-block;
    background-color: #ffffff;
    align-self: center;
    //border: ${(props) => (props.required ? '1px solid var(--main-delete-color)' : '1px solid var(--main-inner-color)')};
    border: ${({ readOnly }) => (readOnly ? 'none' : '1px solid #d0d0d0')};
    //box-shadow: 0px 4px 4px rgba(0, 0, 0, 0.25);
    cursor: pointer;
    &::after {
        float: right;
        //content:  "⌵";
        content: ${({ readOnly }) => (readOnly ? '' : '⌵')};
        //position: absolute;
        margin-right: 5px;
        margin-top: -4px;
        color: #49c181;
        font-size: 20px;
}
`;
const Label = styled.label`
    
    margin-left: 4px;
    text-align: center;
`;
const SelectOptions = styled.ul`
    position: absolute;
    list-style: none;
    z-index: 2;
    //top: 30px;
    //left: 0;
    width: 120px;
    margin-left: -6px;
    overflow: hidden;
    box-shadow: 0px 4px 4px rgba(0, 0, 0, 0.25);
    max-height: 80px;
    max-height: ${(props) => (props.show ? "none" : "0")};
    text-overflow: ellipsis;
    white-space: nowrap;
    overflow: hidden;
    background-color: #222222;
    color: #fefefe;
`;
const Option = styled.li`
    font-size: 14px;
    padding: 6px 8px;
    transition: background-color 0.2s ease-in;
    background-color: ${(props) => (props.index%2 ==0 ? '#222222' : '#383838')};
    border-top: ${(props) => (props.isAddOption ? '2px solid #999' : 'none')};
    &:hover {
        background-color: #595959;
    }
`;

function CustomSelectBox({options, setter, entity, target, subElement, required, value, updator, readOnly, className, ...props}) {
    const [currentLabel, setCurrentLabel] = useState(() => {
        if (!options || options.length === 0) {
            return ""; // options가 비어있을 때 기본값 설정
        }

        const matchedOption = value
            ? options.find(e => e.id === parseInt(value))
            : null;

        return matchedOption ? matchedOption.name : options[0].name;
    });

    const [isShowOptions, setShowOptions] = useState(false);
    const clickRef = useRef(null);

    function setValueForCreate(value) {
        if (!isCollection(subElement)) {
            setter((prevSearchObject) => ({
                ...prevSearchObject,
                [target]: value,
            }));
        } else {
            setCollectionValues(value)
        }
    }


    async function setValueForUpdate(value) {
        if (!isCollection(subElement)) {
        } else {
            const response = await updator.listener({id: updator.id, subId:updator.subId, fieldName: target, value: value});

            if (response.status === 200) {
                handleActiveToast({message: "수정 되었습니다."});
            }else if (response.status === 201) {
                handleActiveToast({message: response.data.message});
            } else if (response.status === 403) {
                handleActiveError({message: "권한이 없습니다."});
            } else if (response.status === 300) {
            } else {
                handleActiveError({message: "알 수 없는 에러 발생."});
            }
        }
    }
    const handleOnChangeSelectValue = (e) => {
        const value = e.target.getAttribute("value")
        const name = e.target.getAttribute("name")

        if(!updator) setValueForCreate(value);
        else  setValueForUpdate(value);
        setCurrentLabel(name);
    };

    const isCollection = (el) => !!el;

    function setCollectionValues(value) {
        const obj = {
            [entity]: {id: subElement.id},
            [target]: value,
        };

        setter(
            prev => {
                const updatedCodes = Array.isArray(prev) ? [...prev] : [];
                updatedCodes[subElement.index] = {
                    ...(updatedCodes[subElement.index] || {}),
                    ...obj
                };
                return updatedCodes;
            }
        );
    }

    const [isModalOpen, setIsModalOpen] = useState(false);
    const modal = props?.modal;
    
    useEffect(() => {
        //외부 클릭시 userMenu 닫음
        function handleClickOutside(event) {
            if (isModalOpen) return;

            if (clickRef.current && !clickRef.current.contains(event.target)) {
                setShowOptions(false);
            }
        }
        document.addEventListener("mousedown", handleClickOutside);
        return () => document.removeEventListener("mousedown", handleClickOutside);
    }, [clickRef, isModalOpen]);

    const handleOpenModal = (e) => {
        e.stopPropagation();
        setIsModalOpen(true);
    }

    const handleCloseModal = () => {
        setIsModalOpen(false);
    }

    const handleUpdateInput = async (e) => {
        if(e.key === "Enter"){
            const val = e.currentTarget.value.trim();
            if(isEmpty(val)) {
                alert("옵션명을 입력해주세요");
                return;
            }

            const r = await modal.create(val, modal);
            if(r?.status === 200) {
                await modal.refresh();
            }
        }
    }

    return (
        <>
            <SelectBox
                className={className}
                readOnly={readOnly}
                required={required}
                onClick={() => {
                    if (!readOnly) setShowOptions((prev) => !prev);
                }}
                ref={clickRef}
            >
                <Label >{currentLabel}</Label>
                <SelectOptions show={isShowOptions} >
                    {options.map((e, index)=> (
                        <Option
                            isAddOption={e.id === "추가"}
                            onClick={(event) => {
                                if(e.id === "추가"){
                                    handleOpenModal(event)
                                }else{
                                    handleOnChangeSelectValue(event)
                                }
                            }}
                            index={index}  value={e.id} name={e.name} className ={``}
                        >{e.name}</Option>
                    ))}
                </SelectOptions>
            </SelectBox>

            {modal &&
                <Modal isOpen={isModalOpen} onClose={handleCloseModal} className={"modal-top"}>
                    <h2 className={"font-bold text-[20px]"}>{modal.title}</h2>
                    <ModalTable>
                        <tbody>
                        <tr>
                            <ModalTh padding={"10px 0 10px 5px"} align={'left'} background={'#f1f6f9'}>옵션명</ModalTh>
                            <ModalTd padding={"10px 15px 10px 5px"}>
                                <input autoFocus className={"border indent-1 focus:outline-none focus:border-[#6f6ff5]"}
                                       onKeyDown={(e) => handleUpdateInput(e)}
                                />
                            </ModalTd>
                        </tr>
                        </tbody>
                    </ModalTable>
                </Modal>
            }
        </>
    );
}

export default CustomSelectBox;